import * as React from 'react';
import { FComponent } from '../../../types/common';
import { Button } from '../Button';
import { Modal } from '../Modal';

export type ProgressMessage = {
  percentFinished: number;
  message: string;
};

type UploadProgressModalProps = {
  isOpen: boolean;
  progress: ProgressMessage;
  toggle: () => void;
};

const UploadProgressModal: FComponent<UploadProgressModalProps> = ({
  isOpen,
  progress,
  toggle
}) => (
  <Modal isOpen={isOpen} toggle={() => null} title="Upload Progress">
    <div className="progress-modal">
      <div className="progress-bar">
        <div style={{ width: `${progress.percentFinished}%` }} />
      </div>
      <span>{progress.message}</span>
    </div>
    <Button
      className={progress.percentFinished === 100 ? '' : 'sr-only'}
      onClick={toggle}>
      Close
    </Button>
  </Modal>
);

export { UploadProgressModal };
